import { Site } from './site';

export interface LookupResponseJSON {
  data: { sites: SiteReplyAPIInterfaceV2 };
}

export interface ChangePrimaryDomainResponseJSON {
  data: ApiSiteMessage;
}

export interface GetSiteResponseV2JSON {
  data: SiteReplyAPIInterfaceV2;
}

export interface LookupAllResponseJSON {
  data: {
    sites: SiteReplyAPIInterfaceV2[];
    cursor_string: string;
  };
}

export class ApiSiteMessage {
  constructor(
    public wordpress_site_id: string,
    public uid: string,
    public domain: string,
    public alternate_domains: string[],
    public title: string,
    public tagline: string,
    public account_group_id: string,
    public partner_id: string,
    public created: string,
    public updated: string,
    public staging_domain: string,
  ) {}

  public static toSite(site: ApiSiteMessage): Site {
    const s = new Site('', '', '', [''], '', '', '', '', '', '', '', false, 0);
    s.siteId = site.wordpress_site_id;
    s.uid = site.uid;
    s.domain = site.domain;
    s.alternateDomains = site.alternate_domains;
    s.title = site.title;
    s.tagline = site.tagline;
    s.accountId = site.account_group_id;
    s.partnerId = site.partner_id;
    s.created = site.created;
    s.updated = site.updated;
    s.stagingDomain = site.staging_domain;
    return s;
  }
}

interface SiteReplyAPIInterfaceV2 {
  site_id: string;
  uid: string;
  primary_domain: string;
  user_id: string;
  title: string;
  tagline: string;
  account_id: string;
  partner_id: string;
  alternate_domains: string[];
  created_datetime: string;
  updated_datetime: string;
  staging_domain: string;
  template: boolean;
  template_version: number;
}

export class SiteReply {
  constructor(
    public siteId: string,
    public uid: string,
    public primaryDomain: string,
    public alternateDomains: string[],
    public title: string,
    public tagline: string,
    public accountId: string,
    public partnerId: string,
    public createdDatetime: string,
    public updatedDatetime: string,
    public stagingDomain: string,
    public template: boolean,
    public templateVersion: number,
  ) {}

  public static fromApi(site_reply: SiteReplyAPIInterfaceV2): SiteReply {
    return new SiteReply(
      site_reply.site_id,
      site_reply.uid,
      site_reply.primary_domain,
      site_reply.alternate_domains,
      site_reply.title,
      site_reply.tagline,
      site_reply.account_id,
      site_reply.partner_id,
      site_reply.created_datetime,
      site_reply.updated_datetime,
      site_reply.staging_domain,
      site_reply.template,
      site_reply.template_version,
    );
  }
}

export class SiteReplies {
  public static fromApi(site_replies: SiteReplyAPIInterfaceV2[]): SiteReply[] {
    const sites: SiteReply[] = [];
    for (const site_reply of site_replies) {
      sites.push(SiteReply.fromApi(site_reply));
    }
    return sites;
  }
}
